import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState, useEffect } from "react";
import { baseURL } from "../../utils/constants";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import logo from "../../assets/images/pngLogo.png";

interface IProps {
  handleFile(file: any | null): void;
  document?: string;
}

export const PdfUploader = ({ handleFile, document }: IProps) => {
  const inputFile = useRef<HTMLInputElement>(null);
  const [localDocument, setLocalDocument] = useState<File | string | null>(
    null
  );

  useEffect(() => {
    if (document && typeof document === "string") {
      setLocalDocument(document);
    }
  }, [document]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = e.target.files?.[0];
    if (!fileUploaded) return;

    if (fileUploaded.size > 15000000) {
      Swal.fire({
        icon: "error",
        text: "Documento demasiado grande, asegúrese de subir uno menor a 15MB",
      });
      return;
    }

    setLocalDocument(fileUploaded);
    handleFile(fileUploaded);
  };

  const handleRemove = () => {
    setLocalDocument(null);
    handleFile(null);
  };

  return (
    <div className="c">
      <img
        className="pointer"
        onClick={() => inputFile.current?.click()}
        src={logo}
        width={200}
        alt="Subir documento"
      />
      <input
        type="text"
        style={{ cursor: "pointer" }}
        className="form-control"
        placeholder="Suba un documento asociado"
        onClick={() => inputFile.current?.click()}
        readOnly
      />
      <input
        type="file"
        ref={inputFile}
        style={{ display: "none" }}
        id="file"
        accept=".pdf,.doc,.docx,.xls,.ppt,.xlsx,.pptx,.odt"
        onChange={handleChange}
      />

      {localDocument && typeof localDocument === "string" && (
        <div className="mt-2 d-flex justify-content-between align-items-center">
          <a
            href={baseURL + localDocument}
            download
            target="_blank"
            rel="noreferrer"
          >
            {localDocument.split("documents")[1]}
          </a>
          <button onClick={handleRemove} className="btn btn-danger btn-sm ml-2">
            Eliminar
          </button>
        </div>
      )}

      {localDocument && typeof localDocument !== "string" && (
        <div className="d-flex mt-2 justify-content-between align-items-center">
          <div>
            <FontAwesomeIcon icon={faCheck} />
            <span className="ml-1">{(localDocument as File).name}</span>
          </div>
          <button onClick={handleRemove} className="btn btn-danger btn-sm ml-2">
            Eliminar
          </button>
        </div>
      )}
    </div>
  );
};
